/**
 * Shared pdf.js loading options for every react-pdf <Document> in the app.
 *
 * With pdf.js defaults (disableStream: false, disableAutoFetch: false) the
 * viewer issues a single GET and streams the whole body to completion, so it
 * never needs — and never sends — a byte range. Large documents therefore
 * download in full before anything is usable.
 *
 * disableStream aborts that full-body read once the response headers report
 * `Accept-Ranges: bytes` + `Content-Length`, which switches pdf.js to HTTP 206
 * range requests. disableAutoFetch then stops it from eagerly pulling the rest
 * of the file in the background, so only the bytes for rendered pages are
 * fetched.
 *
 * Requires the origin serving the PDF to expose `Accept-Ranges`,
 * `Content-Length` and `Content-Range` via CORS, and to allow the `Range`
 * request header.
 *
 * IMPORTANT: react-pdf reloads the document whenever the `options` prop
 * changes identity. Always import this constant — never inline an object
 * literal into <Document options={...} />.
 */
export const PDF_LOAD_OPTIONS = Object.freeze({
  disableRange: false,
  disableStream: true,
  disableAutoFetch: true,
  rangeChunkSize: 1024 * 1024,
});

export default PDF_LOAD_OPTIONS;
